(function() {
  'use strict';
  var lb = document.getElementById('vbg-lightbox');
  var lbImg = document.getElementById('vbg-lightbox-img');
  var lbClose = document.getElementById('vbg-lightbox-close');
  if (!lb || !lbImg) return;
  /* Event Delegation: funktioniert auch wenn Trigger das <img> selbst ist
     (statt einen Wrapper mit Inner-Img zu sein) */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.vbg-lightbox-trigger');
    if (!trigger) return;
    var img = (trigger.tagName === 'IMG') ? trigger : trigger.querySelector('img');
    if (!img || !img.src) return;
    lbImg.removeAttribute('width');
    lbImg.removeAttribute('height');
    lbImg.src = img.src.replace(/width=\d+/, 'width=1600');
    lbImg.alt = img.alt || trigger.alt || '';
    lb.classList.add('active');
    document.body.style.overflow = 'hidden';
  });
  function close() {
    lb.classList.remove('active');
    document.body.style.overflow = '';
  }
  if (lbClose) lbClose.addEventListener('click', close);
  lb.addEventListener('click', function(e) { if (e.target === lb) close(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
})();
